import React from 'react';
import Box from '@mui/material/Box';
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";
import "./styles/styles.scss";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

export default function Drawercomponent({ open, toggleDrawer }) {
    const [color, setColor] = useColor("#561ecb");

    console.log(color, "===== color");

    return (
        <Box sx={{ width: 500, position: "relative", backgroundColor: "#fff", height: "100%" }} role="presentation">
            <ExitToAppIcon sx={{ position: "absolute", right: "10px",top: "10px", fontSize: "28px", cursor: "pointer", color: "#000" }} onClick={toggleDrawer(false)} />
            <div className="custom-layout">
                {/* <Saturation height={300} color={color} onChange={setColor} />
                <Hue color={color} onChange={setColor} /> */}
                <ColorPicker color={color} onChange={setColor} />
            </div>

        </Box>
    )
}
